import { Box, Container } from '@mui/system';
import { Link as LinkMUI, Typography } from '@mui/material';
import { HazardCategories } from './terms';
import { useNavigate } from 'react-router-dom';

const Moderation = () => {
  const navigate = useNavigate();

  const handleRedirect = (e) => {
    e.preventDefault();
    navigate('/terms')
  }

  return (
    <Container
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        py: 3,
        gap: 1.5,
      }}
    >
      <Typography
        variant='h5'
        color='text.primary'
      >
        Moderation Policy
      </Typography>

      <Typography
        variant='body1'
        color='text.secondary'
      >
        We use AI to screen post content for material that violates our <LinkMUI href='/terms' onClick={handleRedirect}>terms and conditions.</LinkMUI> Our content moderation is upheld by assistance of advanced AI Engines. <LinkMUI href='mailto:support@soopra.ai'>Reach out to us via Email</LinkMUI> so we can improve.
      </Typography>

      <Typography
        variant='h6'
        color='text.primary'
      >
        {HazardCategories.title}
      </Typography>

      {
        HazardCategories.listItems.map((item, index) => (
          <TermListItem key={`category-${index}`} item={item} idx={`category-${index}`} />
        ))
      }
    </Container>
  );
};

const TermListItem = (props: any) => {
  let item = props.item;

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 0.5,
        width: '100%',
      }}
    >
      <Typography
        variant='h7'
        color='text.primary'
      >
        {item?.title}
      </Typography>
      <Typography
        variant='body1'
        color='text.secondary'
      >
        {item?.description}
      </Typography>
    </Box>
  )
}

export default Moderation;
